import * as Sentry from "@sentry/nextjs";
import posthog from "@/services/client/analytics/posthog";
import { VIEW_CONTENT_EVENT_NAME } from "./events";
import { facebookViewContent } from "./facebook";

// Host regex does not match
// ^(localhost|127\.0\.0\.1)($|:)

const IS_PRODUCTION_ONLY = false;
const isProduction = process.env.APP_STAGE === "production";

export const isAnalyticsEnabled = () => {
  if (IS_PRODUCTION_ONLY) return isProduction;
  return true;
};

export const logPageview = () => {
  if (isAnalyticsEnabled()) {
    // Does this happen automatically for posthog?
    posthog.capture("$pageview", {
      platform: "web",
      isNative: false,
    });
  }
};

type IdentifyParams = {
  userId: string;
  email?: string;
  name?: string;
  additionalUserParams: object;
};
export const identify = (params: IdentifyParams) => {
  if (!params.userId || !isAnalyticsEnabled()) return;

  const { userId, email, name, additionalUserParams } = params;
  posthog.identify(userId, {
    ...additionalUserParams,
    email,
    name,
  });
  Sentry.setUser({ id: userId, email, name });
};

export const reset = () => {
  if (isAnalyticsEnabled()) {
    posthog.reset();
    Sentry.setUser(null);
  }
};

export const trackEvent = (
  eventName: string,
  eventParams: Record<string, any>,
) => {
  if (isAnalyticsEnabled()) {
    posthog.capture(eventName, {
      ...eventParams,
      platform: "web",
      isNative: false,
    });

    if (typeof window !== "undefined" && (window as any).gtag) {
      (window as any).gtag("event", eventName, eventParams);
    }
  }
};

export const trackEventViewContent = (eventParams: Record<string, any>) => {
  trackEvent(VIEW_CONTENT_EVENT_NAME, {
    ...eventParams,
  });
  facebookViewContent(eventParams);
};
